import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
} from "constants/FormatDataContanst";
import { convertToDD_MM_YYY } from "helpers/utils";

export const getReportStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: t("auth_status_report.m"),
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: t("auth_status_report.p"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: t("auth_status_report.a"),
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_REJECT]: {
      text: t("auth_status_report.r"),
      badgeColor: "badge-soft-danger",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};

export const getTimeContent = cellContent => {
  if (cellContent?.month) {
    return `Tháng ${cellContent?.month}_${cellContent?.year}`;
  }
  if (cellContent?.quarter) {
    return `Quý ${cellContent?.quarter}_${cellContent?.year}`;
  }
  if (cellContent?.date && cellContent?.date.length === 2) {
    const dateFrom = convertToDD_MM_YYY(cellContent?.date[0]);
    const dateTo = convertToDD_MM_YYY(cellContent?.date[1]);

    if (dateFrom === dateTo) {
      return dateFrom;
    } else {
      return `${dateFrom} ~ ${dateTo}`;
    }
  }
  if (cellContent?.date_from && cellContent?.date_to) {
    return `${convertToDD_MM_YYY(
      cellContent?.date_from,
      "_"
    )}_${convertToDD_MM_YYY(cellContent?.date_to, "_")}`;
  }
  return "";
};
